var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardwalletLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "url(#paint0_linear_5574_13975)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5574_13975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5136 21.9071C48.9135 21.9071 50.0485 20.7512 50.0485 19.3254C50.0485 17.8995 48.9135 16.7437 47.5136 16.7437C46.1136 16.7437 44.9787 17.8995 44.9787 19.3254C44.9787 20.7512 46.1136 21.9071 47.5136 21.9071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5136 53.2566C48.9135 53.2566 50.0485 52.1007 50.0485 50.6749C50.0485 49.249 48.9135 48.0931 47.5136 48.0931C46.1136 48.0931 44.9787 49.249 44.9787 50.6749C44.9787 52.1007 46.1136 53.2566 47.5136 53.2566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1968 57.037C37.5968 57.037 38.7317 55.8811 38.7317 54.4553C38.7317 53.0294 37.5968 51.8735 36.1968 51.8735C34.7969 51.8735 33.662 53.0294 33.662 54.4553C33.662 55.8811 34.7969 57.037 36.1968 57.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9706 53.2566C26.3706 53.2566 27.5055 52.1007 27.5055 50.6749C27.5055 49.249 26.3706 48.0931 24.9706 48.0931C23.5706 48.0931 22.4357 49.249 22.4357 50.6749C22.4357 52.1007 23.5706 53.2566 24.9706 53.2566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0904 43.7593C19.4904 43.7593 20.6253 42.6034 20.6253 41.1776C20.6253 39.7517 19.4904 38.5958 18.0904 38.5958C16.6905 38.5958 15.5555 39.7517 15.5555 41.1776C15.5555 42.6034 16.6905 43.7593 18.0904 43.7593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0904 31.4038C19.4904 31.4038 20.6253 30.2479 20.6253 28.8221C20.6253 27.3962 19.4904 26.2404 18.0904 26.2404C16.6905 26.2404 15.5555 27.3962 15.5555 28.8221C15.5555 30.2479 16.6905 31.4038 18.0904 31.4038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9706 21.9071C26.3706 21.9071 27.5055 20.7512 27.5055 19.3254C27.5055 17.8995 26.3706 16.7437 24.9706 16.7437C23.5706 16.7437 22.4357 17.8995 22.4357 19.3254C22.4357 20.7512 23.5706 21.9071 24.9706 21.9071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1968 18.1264C37.5968 18.1264 38.7317 16.9705 38.7317 15.5446C38.7317 14.1188 37.5968 12.9629 36.1968 12.9629C34.7969 12.9629 33.662 14.1188 33.662 15.5446C33.662 16.9705 34.7969 18.1264 36.1968 18.1264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1968 24.2121C36.9468 24.2121 37.5547 23.5928 37.5547 22.829C37.5547 22.0651 36.9468 21.4459 36.1968 21.4459C35.4468 21.4459 34.8388 22.0651 34.8388 22.829C34.8388 23.5928 35.4468 24.2121 36.1968 24.2121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2627 25.8716C43.0126 25.8716 43.6206 25.2524 43.6206 24.4885C43.6206 23.7247 43.0126 23.1055 42.2627 23.1055C41.5127 23.1055 40.9047 23.7247 40.9047 24.4885C40.9047 25.2524 41.5127 25.8716 42.2627 25.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2627 46.8946C43.0126 46.8946 43.6206 46.2753 43.6206 45.5115C43.6206 44.7476 43.0126 44.1284 42.2627 44.1284C41.5127 44.1284 40.9047 44.7476 40.9047 45.5115C40.9047 46.2753 41.5127 46.8946 42.2627 46.8946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1968 48.5539C36.9468 48.5539 37.5547 47.9347 37.5547 47.1708C37.5547 46.4069 36.9468 45.7877 36.1968 45.7877C35.4468 45.7877 34.8388 46.4069 34.8388 47.1708C34.8388 47.9347 35.4468 48.5539 36.1968 48.5539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2219 46.8946C30.9719 46.8946 31.5799 46.2753 31.5799 45.5115C31.5799 44.7476 30.9719 44.1284 30.2219 44.1284C29.472 44.1284 28.864 44.7476 28.864 45.5115C28.864 46.2753 29.472 46.8946 30.2219 46.8946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8762 42.5607C26.6261 42.5607 27.2341 41.9415 27.2341 41.1776C27.2341 40.4138 26.6261 39.7946 25.8762 39.7946C25.1262 39.7946 24.5182 40.4138 24.5182 41.1776C24.5182 41.9415 25.1262 42.5607 25.8762 42.5607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2465 36.3826C24.9965 36.3826 25.6045 35.7634 25.6045 34.9995C25.6045 34.2357 24.9965 33.6165 24.2465 33.6165C23.4966 33.6165 22.8886 34.2357 22.8886 34.9995C22.8886 35.7634 23.4966 36.3826 24.2465 36.3826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8762 30.2054C26.6261 30.2054 27.2341 29.5861 27.2341 28.8223C27.2341 28.0584 26.6261 27.4392 25.8762 27.4392C25.1262 27.4392 24.5182 28.0584 24.5182 28.8223C24.5182 29.5861 25.1262 30.2054 25.8762 30.2054Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2219 25.8716C30.9719 25.8716 31.5799 25.2524 31.5799 24.4885C31.5799 23.7247 30.9719 23.1055 30.2219 23.1055C29.472 23.1055 28.864 23.7247 28.864 24.4885C28.864 25.2524 29.472 25.8716 30.2219 25.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1967 29.0066C36.5967 29.0066 36.9209 28.6764 36.9209 28.269C36.9209 27.8616 36.5967 27.5314 36.1967 27.5314C35.7967 27.5314 35.4724 27.8616 35.4724 28.269C35.4724 28.6764 35.7967 29.0066 36.1967 29.0066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5466 29.9286C39.9466 29.9286 40.2709 29.5984 40.2709 29.191C40.2709 28.7836 39.9466 28.4534 39.5466 28.4534C39.1466 28.4534 38.8224 28.7836 38.8224 29.191C38.8224 29.5984 39.1466 29.9286 39.5466 29.9286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5466 41.5463C39.9466 41.5463 40.2709 41.2161 40.2709 40.8087C40.2709 40.4013 39.9466 40.071 39.5466 40.071C39.1466 40.071 38.8224 40.4013 38.8224 40.8087C38.8224 41.2161 39.1466 41.5463 39.5466 41.5463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1967 42.4682C36.5967 42.4682 36.9209 42.138 36.9209 41.7306C36.9209 41.3232 36.5967 40.9929 36.1967 40.9929C35.7967 40.9929 35.4724 41.3232 35.4724 41.7306C35.4724 42.138 35.7967 42.4682 36.1967 42.4682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8472 41.5463C33.2472 41.5463 33.5715 41.2161 33.5715 40.8087C33.5715 40.4013 33.2472 40.071 32.8472 40.071C32.4472 40.071 32.123 40.4013 32.123 40.8087C32.123 41.2161 32.4472 41.5463 32.8472 41.5463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4934 39.1492C30.8934 39.1492 31.2177 38.819 31.2177 38.4116C31.2177 38.0042 30.8934 37.674 30.4934 37.674C30.0934 37.674 29.7692 38.0042 29.7692 38.4116C29.7692 38.819 30.0934 39.1492 30.4934 39.1492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5882 35.7374C29.9882 35.7374 30.3125 35.4071 30.3125 34.9997C30.3125 34.5923 29.9882 34.2621 29.5882 34.2621C29.1882 34.2621 28.864 34.5923 28.864 34.9997C28.864 35.4071 29.1882 35.7374 29.5882 35.7374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4934 32.3259C30.8934 32.3259 31.2177 31.9956 31.2177 31.5882C31.2177 31.1808 30.8934 30.8506 30.4934 30.8506C30.0934 30.8506 29.7692 31.1808 29.7692 31.5882C29.7692 31.9956 30.0934 32.3259 30.4934 32.3259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8472 29.9286C33.2472 29.9286 33.5715 29.5984 33.5715 29.191C33.5715 28.7836 33.2472 28.4534 32.8472 28.4534C32.4472 28.4534 32.123 28.7836 32.123 29.191C32.123 29.5984 32.4472 29.9286 32.8472 29.9286Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5574_13975",
    x1: 0,
    y1: 0,
    x2: 70,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF55A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#633ABB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5574_13975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.3704,
    height: 45.3704,
    fill: "white",
    transform: "translate(12.3148 12.3147)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardwalletLogo);
export default __webpack_public_path__ + "static/media/cardwallet-logo.d42ca30f7519871541240f342f28f53e.svg";
export { ForwardRef as ReactComponent };